<template>
  <div class="bgc">
    <div class="login_content">
      <h2>hecoos全域制作</h2>
      <input type="text" placeholder="手机/邮箱/ARTBOOK账号/Hirender账号" v-model="form.loginName" />
      <input type="password" placeholder="密码" v-model="form.password" />
      <button :disabled="!isButtonEnabled" @click="handleLogin">登录</button>
      <div class="link-container">
        <span @click="jumpTo('/')">回首页</span>
        <span>|</span>
        <span @click="jumpTo('/register')">注册</span>
        <span>|</span>
        <span @click="jumpTo('/forget_password')">忘记密码?</span>
      </div>
    </div>
  </div>
</template>

<script>
import { adminLogin } from "@/api/api";
import { Message } from "element-ui";
import store from "@/store";
export default {
  data() {
    return {
      form: {
        loginName: "",
        password: "",
      },
    };
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path);
    },
    handleLogin() {
      adminLogin(this.form).then((res) => {

        if (res.code === 200) {
          Message.success('登录成功');
          res.data.work_duration = res.data.work_duration  ? parseInt(res.data.work_duration) + '年' :''
          store.dispatch("saveAdminUserInfo", res.data);
          localStorage.setItem("token", JSON.stringify(res.data.token));
          if (localStorage.getItem('orderMsg')) {
            this.$router.push("/SoftwareSubscriptions");
          } else {
            setTimeout(() => {
              this.$router.push("/personalCenter");
            }, 1000);
          }
        } else {
          Message.error(res.message);
        }
      });
    },
  },
  computed: {
    isButtonEnabled() {
      return this.form.password.length >= 6;
    },
  },
};
</script>

<style lang="scss" scoped>
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  // background: linear-gradient(to bottom right, #6f22ff, #000);
  min-height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.login_content {
  background-color: #222;
  width: 550px;
  padding: 30px 50px;
  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.login_content h2 {
  color: #fff;
  margin-bottom: 30px;
  font-size: 24px;
}

.login_content input {
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
}

.login_content button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  font-size: 18px;
}

.login_content button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  margin-top: 15px;
  color: #fff;
  font-size: 18px;
}

.link-container span {
  cursor: pointer;
  margin: 0 5px;
}
</style>
